<template>
  <div class="app-container">
    <div class="formBox margbot" ref="searchBox">
      <el-form :inline="true" class="demo-form-inline" :model="searchForm" label-width="90px" size="mini" style="width:100%">
        <div class="formItemBox">
        <el-form-item label="始发流向:"  prop="versionTitle"  >
          <el-input  placeholder=""   maxlength="30" v-model="searchForm.startDirection"  ></el-input>
        </el-form-item>
         <el-form-item label="目的流向:"  prop="versionTitle"  >
          <el-input  placeholder=""   maxlength="30" v-model="searchForm.endDirection"  ></el-input>
        </el-form-item>
        </div>
        <div style="display: flex;align-items: center;padding-right: 20px;">
          <div class="searchBtnBox" style="flex-shrink:0">
            <el-button type="primary" size="mini" @click="searchFn">查询</el-button>
            <el-button type="primary" size="mini" @click="resetForm('searchForm')">重置</el-button>
            <el-button type="primary" @click="exportFn" size="mini" :disabled="isDaoChu">导出</el-button>
          </div>
        </div>
      </el-form>
    </div>
    <!--  表格 -->
    <div class="table" :style="{ height: h }">
      <el-table :data="tableList" ref="table" bordersize="mini" height="100%" style="width: 100%" class="tableComent" :cell-style="setCellStyle" highlight-current-row center border >
        <!-- <el-table-column type="selection" width="55"></el-table-column> -->
        <el-table-column type="index" prop="date" width="55" label="序号"></el-table-column>
        <el-table-column prop="startDirection" label="始发流向" min-width="200"></el-table-column>
        <el-table-column prop="endDirection" label="目的流向" min-width="200"></el-table-column>
        <el-table-column prop="averageKilometres" label="平均公里数" min-width="100"></el-table-column>
        <el-table-column prop="value3" label="单趟单吨最低收入单价"  min-width="120">
          <template slot-scope="scope">
              <div>
               {{ toFixed(scope.row.incomeMinUnitPrice/100 ,2)}}
              </div>
            </template>
        </el-table-column>
         <el-table-column prop="value3" label="单趟单吨最高收入单价" min-width="120">
          <template slot-scope="scope">
              <div>
               {{ toFixed(scope.row.incomeMaxUnitPrice/100 ,2)}}
              </div>
            </template>
        </el-table-column>
         <el-table-column prop="value3" label="单趟单吨平均收入单价" min-width="120">
          <template slot-scope="scope">
              <div>
               {{ toFixed(scope.row.incomeAverageUnitPrice/100 ,2)}}
              </div>
            </template>
        </el-table-column>
         <el-table-column prop="value3" label="单趟单吨最低支出单价" min-width="120">
          <template slot-scope="scope">
              <div>
               {{ toFixed(scope.row.freightMinUnitPrice/100 ,2)}}
              </div>
            </template>
        </el-table-column>
         <el-table-column prop="value3" label="单趟单吨最高支出单价" min-width="120">
          <template slot-scope="scope">
              <div>
               {{ toFixed(scope.row.freightMaxUnitPrice/100,2 )}}
              </div>
            </template>
        </el-table-column>
        <el-table-column prop="value3" label="单趟单吨平均支出单价" min-width="120">
          <template slot-scope="scope">
              <div>
               {{ toFixed(scope.row.freightAverageUnitPrice/100,2) }}
              </div>
            </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页-->
    <div>
      <el-pagination background @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="searchForm.pageNo" :page-sizes="[ 25,50, 100,200]" :page-size="searchForm.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import { getBtn } from '@/utils/getButton'
import { directionPriceModelList } from '@/api/newTMS'
import { dateFormat1, dateTimeFormat, emptyFn, toFixed } from '@/utils/util'
import { exportExcel } from '@/utils/fileDownXlsx.js'
export default {
  name: 'BasicMeterial',
  components: { },
  data () {
    return {
      toFixed: toFixed,
      emptyFn: emptyFn,
      dateTimeFormat: dateTimeFormat,
      searchForm: {
        pageNo: 1,
        pageSize: 50
      },
      tableList: [],
      teamNames: [],
      total: 0,
      // 按钮
      btnFlg: [],
      btnIdArr: [],
      h: '',
      isDaoChu: false
    }
  },
  created () {
    this.btnFlg = getBtn(this.btnIdArr, '/carStatusDistribution')
    this.masterList()
  },
  mounted () {
    let h = this.$refs.searchBox.offsetHeight
    let pH = document.documentElement.clientHeight
    this.h = pH - h - 160 + 'px'
  },
  methods: {
    // 设置单元格样式
    setCellStyle ({ row, column, rowIndex, columnIndex }) {
      // 判断 teamName 是否为"合计"
      if (row.value1 === '合计') {
        // 如果是序号列，将内容设为空字符串
        if (column.type === 'index') {
          return {
            color: '',
            fontWeight: '',
            '&::before': {
              content: '""' // 伪元素方式清空内容
            }
          }
        }
        return {
          color: '#1890ff',
          fontWeight: 'bold'
        }
      }
      return null
    },
    getYesterday () {
      const date = new Date()
      date.setDate(date.getDate() - 1)
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    masterList () {
      const loading = this.$loading({
        lock: true,
        text: '加载中...'
      })
      directionPriceModelList(this.searchForm)
        .then(res => {
          this.tableList = res.list
          this.total = res.total
          loading.close()
        })
        .catch(err => {
          this.$message({
            showClose: true,
            message: err.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
    },
    searchFn () {
      this.masterList()
    },
    // 重置
    resetForm (formName) {
      this.searchForm = {}
      this.searchFn()
    },
    // 每页条数
    handleSizeChange (val) {
      this.searchForm.pageSize = val
      this.masterList()
    },
    // 当前页
    handleCurrentChange (val) {
      this.searchForm.pageNo = val
      this.masterList()
    },
    // 导出
    exportFn () {
      this.searchForm.startTimeString = this.searchForm.queryDate + ' 00:00:00'
      this.searchForm.endTimeString = this.searchForm.queryDate + ' 23:59:59'
      let form = { ...this.searchForm }
      exportExcel(
        this.global.tmsPlus + '/directionPriceModel/exportDirectionPriceModel',
        form,
        '流向收支模型'
      )
      this.isDaoChu = true
      setTimeout(() => {
        this.isDaoChu = false // 点击一次时隔两秒后才能再次点击
      }, 2000)
    }
  }
}
</script>

<style scoped lang="less">
</style>
